<script lang="ts">
    
    import type { Game } from "../../Model/Game";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";
    import { GameTypeService } from "../../Services/GameTypeService";

    export let game: Game;

    const gameSubscriptions = new SubscriptionsManager();

    let indicatorText = '';

    $: setupGame(game);

    function setupGame(game: Game): void {
        gameSubscriptions.unsubscribeAll();
        if (!game) {
            indicatorText = '';
            return;
        }
        gameSubscriptions.subscribe(game.numbers, numbers => {
            indicatorText = `${numbers.length}/${GameTypeService.getMaxNumbers(game.type)}`;
        });
    }

</script>

{indicatorText}
